import React from "react";
import HelloText from "../components/HelloText";
import useSWR from "swr";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Button } from "@mui/material";
const Menu = () => {
  const { data, error } = useSWR(process.env.REACT_APP_DEF_URL + "megaHead");

  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <div className="categories">
      <HelloText />
      <p style={{ marginLeft: "40px", marginBottom: "20px" }}>
        Menu Kategorileri
      </p>
      <Link to={"/menu/add"}>
        <Button
          variant="outlined"
          sx={{
            marginLeft: "40px",
            marginBottom: "20px",
          }}
        >
          Ekle
        </Button>
      </Link>
      <div className="flex">
        <div className="categories-lists">
          {data.map((data) => (
            <Box
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
            >
              <nav aria-label="main mailbox folders">
                <List>
                  <Link to={"/menu/" + data.head_id}>
                    <ListItem disablePadding>
                      <ListItemButton>
                          <ListItemText
                            primary={data.head_name}
                          />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
              </nav>
            </Box>
          ))}
        </div>
      </div>
      <div className=""></div>
    </div>
  );
};

export default Menu;
